<template>
  <div>
    <a-modal width="800px" v-model="isShow" :title="title" :afterClose="handleCancel" :maskClosable="false">
      <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-model-item label="发布平台" prop="line_id">
          <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择"
                    @change="orgChange" style="width: 80%">
            <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="平台分类" prop="platform">
          <a-select v-model="form.platform" allowClear show-search option-filter-prop="children" placeholder="请选择"
                    style="width: 80%">
            <a-select-option v-for="item in PLATFORM" :key="item.key" :value="item.key">{{ item.value
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="控制配置" prop="control_type">
          <a-select v-model="form.control_type" :disabled="isEdit" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 80%">
            <a-select-option :value="1">官方信息</a-select-option>
            <a-select-option :value="2">模块功能</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="form.control_type === 2" label="模块名称" prop="module_name">
          <a-input v-model.trim="form.module_name" placeholder="请输入" :maxLength="50" style="width: 80%" />
        </a-form-model-item>
        <a-form-model-item v-if="form.control_type === 1" label="类型" prop="type_id">
          <a-select v-model="form.type_id" allowClear show-search option-filter-prop="children" placeholder="请选择"
                    @change="typeChange" style="width: 80%">
            <a-select-option v-for="item in contactTypeList" :key="item.id" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="内容:" v-if="dataType && form.control_type === 1" prop="contact">
          <a-input v-if="dataType === 1" v-model.trim="form.contact" placeholder="请输入" style="width: 80%" />
          <template v-if="dataType === 2">
            <a-upload name="file" :headers="{ token }" :before-upload="beforeUpload" list-type="picture-card"
                      class="avatar-uploader" :show-upload-list="true" :action="`${baseURL}/public/upload-file-qi-niu`"
                      @change="(data) => handleChange(data)" :file-list="fileList" @preview="preview">
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
            <span>1、仅支持png、jpg、jpeg格式图片上传<br>2、仅支持上传单张，单张图片不超过2M</span>
          </template>
          <template v-if="dataType === 3">
            <Editor v-model="form.contact" style="width: 600px" />
          </template>
        </a-form-model-item>
        <a-form-model-item label="标识" prop="flag">
          <a-input v-model.trim="form.flag" placeholder="请输入" style="width: 80%" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="2">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取 消 </a-button>
        <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
      </template>
      <a-modal :visible="previewVisible" width="720px" :footer="null" @cancel="preViewCancel">
        <div class="preViewImg">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </div>
      </a-modal>
    </a-modal>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, watch, computed, watchEffect } from '@vue/composition-api'
import { form, rules } from './business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from './business/index'
import api from '@/api/'
import token from '@/composables/token'
import storeGlobal from '@/store/'
import Editor from '@/components/Editor1/Editor.vue'
import { cloneDeep } from 'lodash'
const title = {
  Add: '新增',
  Edit: '编辑'
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: Array,
      default: () => []
    },
    PLATFORM: {
      type: Array,
      default: () => []
    },
    FORMAT: {
      type: Array,
      default: () => []
    },
    contactTypeList: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Editor
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      ...token(),
      title: title.Add,
      btnloading: false,
      principalList: [], // 负责人
      form: { ...form },
      fileList: [],
      baseURL: process.env.VUE_APP_API_BASE_URL,
      previewVisible: false,
      previewImage: '',
      dataType: ''
    })
    const labels = computed(() => {
      return storeGlobal.state.label.data
    })

    watch(() => props.value, (newVal) => {
      if (newVal) return
      state.form = { ...form }
      state.fileList = []
      state.previewVisible = false
      state.previewImage = ''
      state.dataType = ''
    }, { immediate: true, deep: true })

    watch(
      () => _this.params,
      async () => {
        if (!_this.isEdit) return
        const params = cloneDeep(_this.params)
        _this.dataType = Number(params.contactType?.format)
        setTimeout(() => {
          state.form = {
            ...params, type_id: Number(params.type_id),
            platform: Number(params.platform), status: Number(params.status),
          }
          if (_this.dataType === 2) {
            state.fileList = [{
              uid: Date.now(),
              name: `${Date.now()}`,
              status: 'done',
              url: state.form.oss_domains + '/' + state.form.contact
            }]
          }
        }, 300)
        const responsible = state.form.responsible_name + '(' + state.form.responsible_number + ')'
        _this.$set(state.form, 'responsible', responsible)
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )

    const methods = {
      orgChange(val, selectedOptions) {
        if (val) {
          const select_item = _this.platformList.find((item) => item.id.toString() === val.toString())
          const { project, staff_style, type } = select_item
          state.form.project = project
          state.form.staff_style = staff_style
          state.form.type = type
        } else {
          state.form.line_id = undefined
          state.form.project = undefined
          state.form.staff_style = undefined
          state.form.type = undefined
        }
      },
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const isJpgOrPng =
            file.type === 'image/jpeg' ||
            file.type === 'image/jpg' ||
            file.type === 'image/png'
          if (!isJpgOrPng) {
            this.$message.error('请上传图片!')
            return reject(new Error(false))
          }
          const isLt2M = file.size / 1024 / 1024 <= 2
          if (!isLt2M) {
            this.$message.error('图片大小不超过 2MB!')
            return reject(new Error(false))
          }
          return resolve(true)
        })
      },
      handleChange(data) {
        this.fileList = data.fileList
        if (this.dataType === 2) {
          this.form.contact = data.fileList[0]?.response
            ? data.fileList[0].response.data.url
            : ''
        }
      },
      preview(file) {
        this.previewImage = file.url || this.labels.QI_NIU_DOMAINS + '/' + file.response.data.url
        this.previewVisible = true
      },
      preViewCancel() {
        this.previewVisible = false
      },
      typeChange(val) {
        this.dataType = this.contactTypeList.find(item => item.id === val).format
        this.form.contact = undefined
      },
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.form }
          if (valid) {
            if (_this.isEdit) {
              res = await api.contactUpdate(data)
            } else {
              res = await api.contactCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
              _this.$refs.formDom.resetFields()
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        state.form.contact = undefined
        state.fileList = []
        _this.form.status = 1
        _this.isShow = false
      },
      handleCancelCategory() {
        if (!_this.isEdit) {
          _this.form.typeids = []
          _this.form.sync_xml_loc = ''
        }
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods,
      labels
    }
  }
})
</script>
<style scoped lang="less">
.preViewImg {
  padding: 10px 20px;
}
</style>
